<div
    *ngIf="_isVisible"
    [@slideInLeft]
    [ngClass]="{ 'show-data-mode': isInitialStateEmpty ? false : true }"
    class="container-view left-first-level-container"
>
    <div class="container-view__wrapper">
        <div class="header">
            <h1 class="header__title">
                {{ 'reports.title'|translate }}
            </h1>

            <div *ngIf="isGeneretingRaport && !isLoadingReport" class="header__exports">
                <span class="header__exports__title">
                    {{'reports.exportRaport' | translate}}:
                </span>

                <button (click)="generateXlsFile()" class="header__exports__btn xls">
                    <i class="pi pi-file-o"></i>
                </button>
                <button (click)="generatePDFFile()" class="header__exports__btn pdf">
                    <i class="pi pi-file-pdf"></i>
                </button>
            </div>
        </div>

        <div class="header__row">
            <div class="header__filters">
                <app-filter-control
                    *ngIf="filtersVehicleConfig"
                    [selectedControlValue]="filtersVehicleCurrentFilters"
                    (onSubmitFilters$)="onChangeVehicleFilters($event, filtersVehicleConfig)"
                    [data]="filtersVehicleConfig"
                    [isVisibleSearchInput]="true"
                    [optionsSelectedCount]="filtersVehicleCurrentFilters?.selectedControlValue ? 1 : 0"
                    class="header__filters__vehicle"
                ></app-filter-control>
                <app-date-picker
                  [numberOfMonths]="2"
                  [(ngModel)]="selectedDate"
                  selectionMode="range"
                  [maxRangeDays]="7"
                  [maxSelectableDays]="7"
                  [timeRangeTipsData]="datepickerTimeRangeTipsData"
                  [isVisibleTimePicker]="true"
                ></app-date-picker>
                <p-button
                    (onClick)="submitFilters()"
                    [disabled]="!selectedDate?.length || !filtersVehicleCurrentFilters"
                    class="header__filters__submit"
                    [label]="'reports.generateReport'|translate"
                />
            </div>
        </div>

    <div *ngIf="isInitialStateEmpty" class="empty-state">
        <div class="empty-state__wrapper">
            <div class="empty-state__wrapper__content">
                <img src="/assets/img/emty-cars-params-chart.svg" alt="">

                <div class="empty-state__wrapper__content__text">
                    <span class="title">{{'chartParams.noDataDisplay' | translate}}</span>
                    <span class="desc">{{'chartParams.noDataDisplay2' | translate}}</span>
                </div>
            </div>
        </div>
    </div>

    <div *ngIf="isGeneretingRaport && !isLoadingReport" class="content" id="report-content">
        <div class="content__header">
            <div class="content__header__column-top">
                <div class="left">
                    <span class="title">
                        {{ selectedVehicle.Nm }}
                    </span>
                    <button (click)="showAllRoutesOnMap()" class="show-all-routes"><b>{{'reports.showAllRoutes' | translate}}</b></button>
                </div>
                <div class="right">
                    <button (click)="changeSortDays(SortMode.Latest)" [ngClass]="{'active': sortMode === SortMode.Latest}" [disabled]="sortMode === SortMode.Latest" class="sort newset">
                        {{'reports.sortLatest'|translate}}
                    </button>
                    <button (click)="changeSortDays(SortMode.Oldest)" [ngClass]="{'active': sortMode === SortMode.Oldest}" [disabled]="sortMode === SortMode.Oldest" class="sort older">
                        {{'reports.sortOldest'|translate}}
                    </button>
                    <!-- <button class="settings">
                        <i class="pi pi-cog"></i>
                    </button> -->
                </div>
            </div>
            <app-summary-route [data]="vehicleRouteStatisticSummary"></app-summary-route>
        </div>
        <app-report-day-route-preview
            *ngFor="let item of groupRoutes; let index = index; trackBy: trackByGroupRoutes"
            (onSelectRoute$)="onSelectRoute($event, index)"
            (toggleVisibility$)="toggleVisibilityGroup(item, index)"
            [data]="item"
            [isVisibleContent]="statusVisibleGroups.get(item.id) || false"
            [selectedRoute]="selectedRoute"
        ></app-report-day-route-preview>
    </div>

    <app-route-reports-skeleton-loader *ngIf="isLoadingReport"></app-route-reports-skeleton-loader>
</div>

<app-route-details-modal
    (prevRoute$)="selectPrevRoute()"
    (nextRoute$)="selectNextRoute()"
    [isVisible]="isVisibleRouteDetailsModal"
    [vehicle]="selectedVehicle"
    [routeData]="selectedRoute"
    [groupRoutes]="groupRoutes[selectedGroupIndex]"
></app-route-details-modal>
